import FbPixel from "src/utils/FbPixel";
import { fetchData, Method } from "@/utils/fetcher";

const SubscribeUri = `/login-api/api/v2/subscription`;

// 쿼리는 URLSearchParams 로만 조립한다. 원문 그대로 붙이면 login(Tomcat)이 `+` 를 공백으로 읽어
// `a+b@x.com` 이 `a b@x.com` 으로 구독되고, `&`·`#` 에서 파라미터가 끊긴다.
const subscriptionUrl = (path: string, params: Record<string, string>) =>
  `${SubscribeUri}/${path}/?${new URLSearchParams(params)}`;

class SubscriptionService {
  // AtH 랜딩 "Notify me" 게임 릴리즈 구독 등록 (login BE, dev). BE 계약: Notion 2026-07-22 / login#357.
  // 기존 restock 3종과 달리 POST + 선택적 Bearer.
  //  - slug 생략 → "전체 신작"(ai-powered-new) 토픽 구독
  //  - 로그인: token 만 실으면 서버가 email/uid 해석(email 생략) / 게스트: email 필수
  //  - source: 동의 provenance 필수(기본 "ath-landing", 뉴스레터 간주동의 감사 재발 방지).
  //    새 유입 표면(GNB/PDP 등)이 생기면 호출부에서 각자 provenance 전달 → 오귀속 방지
  //  - 멱등: 같은 email+slug 재구독은 no-op 성공
  static notifyGameRelease = async ({
    slug,
    email,
    token,
    source = "ath-landing",
  }: {
    slug?: string;
    email?: string;
    token?: string;
    source?: string;
  }): Promise<boolean> => {
    try {
      // fetchData: 응답 status true 면 message resolve, false 면 errorMessage reject → 성공 판정 위임
      await fetchData({
        url: `${SubscribeUri}/game-release/`,
        method: Method.POST,
        token,
        data: {
          ...(slug ? { slug } : {}),
          ...(email ? { email } : {}),
          source,
        },
      });
      return true;
    } catch (e) {
      console.error(e);
      return false;
    }
  };

  static notifyStock = async ({
    email,
    productName,
    countryCode,
    sku = "",
  }: {
    countryCode: string;
    email: string;
    productName: string;
    sku?: string;
  }): Promise<boolean> => {
    if (!email || !productName) {
      return false;
    }
    try {
      const res = await fetch(
        subscriptionUrl("restock", {
          product: sku || productName,
          email,
          newsletter: "false",
          country: countryCode,
        }),
      );
      return res.ok;
    } catch (e) {
      console.error(e);
      return false;
    }
  };

  static notifyStockAndSubscribe = async ({
    email,
    productName,
    countryCode,
    sku = "",
  }: {
    email: string;
    productName: string;
    countryCode: string;
    sku?: string;
  }): Promise<boolean> => {
    if (!email || !productName || !countryCode) {
      return false;
    }
    try {
      const res = await fetch(
        subscriptionUrl("restock", {
          product: sku || productName,
          email,
          newsletter: "true",
          country: countryCode,
        }),
      );
      return res.ok;
    } catch (e) {
      console.error(e);
      return false;
    }
  };

  static subscribe = async (email: string): Promise<boolean | any> => {
    if (!email) {
      return false;
    }
    try {
      const res = await fetch(subscriptionUrl("subscribe", { email }));
      if (res.ok) {
        FbPixel.completeRegistration();
      }
      return res.json();
    } catch (e) {
      console.error(e);
      return false;
    }
  };
}

export default SubscriptionService;
